export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/13cxx5eyFddxEu4QiET3qf/PAGINA_3.jpg',
    alt: 'Sample page Genetics Is the Science of Heredity and Variation, introducing heredity, variation, the molecule, the cell and populations',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jRuqB3DfVyXup5m9FkpjJj/PAGINA_12.jpg',
    alt: "Sample page 1953: The Model That Explained Heredity, describing Watson and Crick's double-helix model",
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6xHM8Soeq3N38yPKBhLCZJ/PAGINA_17.jpg',
    alt: 'Sample page A Twisted Ladder with a Backbone Outside and a Code Inside, labelling the shape of the double helix',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/46ygAkFZjoffMD6KsoRXft/PAGINA_25.jpg',
    alt: 'Sample page Body Cells Have Two Sets. Sex Cells Have One, comparing haploid and diploid cells with a key takeaway and a common misconception',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/p3S7rVMBGer5Pi7f6VQdpc/PAGINA_50.jpg',
    alt: 'Sample page The Molecule of Life Field Card, summarizing DNA structure, pairing, packing, chromosomes, human numbers, cell cycle and replication',
  },
];
